import { Placement } from 'react-joyride';
import { BaseTour } from '../BaseTour';

export class RateCardChargesTour extends BaseTour {
  id = 'rate-card-charges';

  content = 'Rate Card Manager - Charge Details';

  placement: Placement = 'bottom';

  steps = {
    validityPeriodSelection: () => ({
      content:
        'Select a Validity Period from the dropdown to view the charges configured for that time range. You can create a new period by copying from an existing one (preloads charges grouped by type), or creating a blank period and adding charges manually.',
      placement: 'bottom' as Placement,
    }),

    chargesTable: () => ({
      content:
        'Edit charge values directly in table cells using inline editing. You can also bulk copy-paste rows using Ctrl/Cmd + C and Ctrl/Cmd + V. This works within the same period or across periods. Use the Delete button on the left side to remove rows.',
      placement: 'top' as Placement,
    }),

    rateCardDiscountTab: () => ({
      content:
        "If discounts are configured for a shipping service, you'll see a Rate Card Discount tab next to Charge Details. Switch to this tab and select a Validity Period to view, add, edit, or delete discounts - including fields like: Discount Name, Eligible Charge Domain, Rate, Start / End Date.",
      placement: 'bottom' as Placement,
    }),
  } as const;
}
